module.exports = __webpack_public_path__ + "static/revolution-mobile-255793fe6ffbeaf314d0570ae5072e7f.jpg";